import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=5a064b0a&scoped=true"
import script from "./CmsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CmsContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a064b0a",
  null
  
)

export default component.exports